import {
    FETCH_TIMESHEET_MANAGER_INBOX_REQUEST,
    FETCH_TIMESHEET_MANAGER_INBOX_SUCCESS,
    FETCH_TIMESHEET_MANAGER_INBOX_FAIL,
    FETCH_TIMESHEET_ADMIN_INBOX_REQUEST,
    FETCH_TIMESHEET_ADMIN_INBOX_SUCCESS,
    FETCH_TIMESHEET_ADMIN_INBOX_FAIL,
    TIMESHEET_MANAGER_DECISION_SUCCESS,
    TIMESHEET_ADMIN_DECISION_SUCCESS,

    FETCH_TIMESHEET_MANAGER_HISTORY_REQUEST,
    FETCH_TIMESHEET_MANAGER_HISTORY_SUCCESS,
    FETCH_TIMESHEET_MANAGER_HISTORY_FAIL,
    FETCH_TIMESHEET_ADMIN_HISTORY_REQUEST,
    FETCH_TIMESHEET_ADMIN_HISTORY_SUCCESS,
    FETCH_TIMESHEET_ADMIN_HISTORY_FAIL,
} from "../actions/timesheetWorkflowActions";

const initialState = {
    managerInbox: [],
    adminInbox:   [],
    managerHistory: [],
    adminHistory:   [],
    loading:      false,
    error:        null,
};

export default function timesheetWorkflowReducer(state = initialState, action) {
    switch (action.type) {

        case FETCH_TIMESHEET_MANAGER_INBOX_REQUEST:
        case FETCH_TIMESHEET_ADMIN_INBOX_REQUEST:
        case FETCH_TIMESHEET_MANAGER_HISTORY_REQUEST:
        case FETCH_TIMESHEET_ADMIN_HISTORY_REQUEST:
            return action.meta?.silent ? { ...state, error: null } : { ...state, loading: true, error: null };

        case FETCH_TIMESHEET_MANAGER_INBOX_SUCCESS:
            return { ...state, loading: false, managerInbox: action.payload || [] };

        case FETCH_TIMESHEET_ADMIN_INBOX_SUCCESS:
            return { ...state, loading: false, adminInbox: action.payload || [] };

        case FETCH_TIMESHEET_MANAGER_HISTORY_SUCCESS:
            return { ...state, loading: false, managerHistory: action.payload || [] };

        case FETCH_TIMESHEET_ADMIN_HISTORY_SUCCESS:
            return { ...state, loading: false, adminHistory: action.payload || [] };

        case FETCH_TIMESHEET_MANAGER_INBOX_FAIL:
        case FETCH_TIMESHEET_ADMIN_INBOX_FAIL:
        case FETCH_TIMESHEET_MANAGER_HISTORY_FAIL:
        case FETCH_TIMESHEET_ADMIN_HISTORY_FAIL:
            return { ...state, loading: false, error: action.payload };

        case TIMESHEET_MANAGER_DECISION_SUCCESS:
            return {
                ...state,
                loading: false,
                managerInbox: state.managerInbox.filter((t) => t.id !== action.payload.id),
            };

        case TIMESHEET_ADMIN_DECISION_SUCCESS:
            return {
                ...state,
                loading: false,
                adminInbox: state.adminInbox.filter((t) => t.id !== action.payload.id),
            };

        default:
            return state;
    }
}
